import {
  Button,
  JoonUIColor,
  Modal,
  ModalHeader,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import { create } from "zustand"

import { useQuestModalStore } from "./useQuestModalStore"
import { useDeleteQuestMutation } from "../../../networking/quests/mutations"

interface DeleteQuestModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useDeleteQuestModalStore = create<DeleteQuestModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
)

const DeleteQuestModal = () => {
  const { isOpen, onClose: closeDeleteModal } = useDeleteQuestModalStore()
  const { questGroup, onClose: closeQuestModal } = useQuestModalStore()
  const deleteQuestMutation = useDeleteQuestMutation()

  const handleDelete = async () => {
    if (!questGroup) return

    await deleteQuestMutation.mutateAsync({
      questSeriesId: questGroup[0].series.id,
      date: questGroup[0].date,
    })
    closeDeleteModal()
    closeQuestModal()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeDeleteModal}
      className="w-[400px] max-w-[95vw]"
    >
      <ModalHeader
        title="Confirm deletion"
        onClose={closeDeleteModal}
        showBorderBottom
      />
      <div className="flex flex-col gap-6 p-6 pt-4">
        <Typography variant="body">
          Are you sure? Once deleted, you won't be able to view this task
          anymore.
        </Typography>
        <div className="flex flex-row gap-4 items-center justify-end">
          <TextButton onClick={closeDeleteModal}>
            <Typography variant="body" color={JoonUIColor.text.primaryAccent}>
              No, cancel
            </Typography>
          </TextButton>
          <Button
            text="Yes, delete"
            onClick={handleDelete}
            isLoading={deleteQuestMutation.isLoading}
            buttonType="redPrimary"
          />
        </div>
      </div>
    </Modal>
  )
}

export default DeleteQuestModal
